import { createSlice, PayloadAction } from "@reduxjs/toolkit";

const initialState: boolean = false;

const marketingSlice = createSlice({
  initialState,
  name: "marketing",
  reducers: {
    setMarketing: (state: boolean, action: PayloadAction<boolean>) => {
      return action.payload;
    },
  },
});

export const { setMarketing } = marketingSlice.actions;

export default marketingSlice.reducer;
